import * as tenantDeliveryMethodsModule from '../data/tenantDeliveryMethods.json';
export const DeliveryMethodsEnum = Object.freeze({
    EAT_IN: 0,
    PARKING_LOT: 1,
    TAKE_OUT: 2,
    DELIVERY: 3,
    DRIVE_IN: 4,
    DRIVE_THROUGH: 5,
});
export const getDeliveryMethodByNumberValue = (deliveryOption) => getEnumKeys().find((key) => DeliveryMethodsEnum[key] === deliveryOption);
export const deliveryMethodForDisplay = (deliveryMethod) => {
    if (deliveryMethod in DeliveryMethodsEnum) {
        const deliveryOption = deliveryMethod.split('_').join(' ').toLowerCase();
        return deliveryOption.charAt(0).toUpperCase() + deliveryOption.slice(1);
    }
    throw new Error(`You should sent one of the keys: ${Object.getOwnPropertyNames(DeliveryMethodsEnum)}`);
};
export const getEnumKeys = () => {
    return Object.keys(DeliveryMethodsEnum);
};
export const getEnumValues = () => Object.values(DeliveryMethodsEnum);
const tenantDeliveryMethods = ('default' in tenantDeliveryMethodsModule ? tenantDeliveryMethodsModule.default : tenantDeliveryMethodsModule);
export const DeliveryMethodsAdditionalData = Object.freeze(tenantDeliveryMethods);
